import { render, staticRenderFns } from "./educational-material-box.vue?vue&type=template&id=e688bd8c&scoped=true&"
import script from "./educational-material-box.vue?vue&type=script&lang=js&"
export * from "./educational-material-box.vue?vue&type=script&lang=js&"
import style0 from "./educational-material-box.vue?vue&type=style&index=0&id=e688bd8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e688bd8c",
  null
  
)

export default component.exports